<div class="summary card">
    <card i18n-headerTitle headerTitle="Summary" [hasFooter]="false">
        <div card-body class="card-body">
            <ng-container *ngIf="accountSnapshotDataSource.error$ | async">
                <div class="card-error">
                    <p>{{ dataSourceErrorCopy }}</p>
                </div>
            </ng-container>
            <ng-container *ngIf="!(accountSnapshotDataSource.error$ | async)">
                <lsq-circle-loader
                    *ngIf="accountSnapshotDataSource.loading$ | async"
                ></lsq-circle-loader>
                <div
                    *ngIf="!(accountSnapshotDataSource.loading$ | async)"
                    class="account-snapshot-body"
                    [ngClass]="{ 'card-body': !isMobile }"
                >
                    <div
                        class="snapshot-item mobile-amount-cluster-card"
                        (click)="
                            goToLinkOnMobile(
                                !!debtorKey
                                    ? getCustomerLink(agingByCustomerRouterLinkUrl)
                                    : agingRouterLinkUrl
                            )
                        "
                    >
                        <dashboard-amount-cluster
                            [useCurrencyPipe]="true"
                            [label]="
                                ((
                                    accountSnapshotData$ | async
                                )?.unpaidInvoicesCount).toLocaleString('en-US') + ' Unpaid Invoices'
                            "
                            i18n-label="[# of unpaid invoices] Unpaid Invoices"
                            [linkDestination]="
                                !!debtorKey
                                    ? getCustomerLink(agingByCustomerRouterLinkUrl)
                                    : agingRouterLinkUrl
                            "
                            tooltipText="Invoices that your customers haven't paid yet."
                            i18n-tooltipText="Unpaid Invoices dashboard tooltip"
                            [value]="(accountSnapshotData$ | async)?.unpaidInvoicesAmount"
                        >
                        </dashboard-amount-cluster>
                        <lsq-icon
                            *ngIf="isMobile"
                            [type]="icons.ChevronRight"
                            [color]="color.Gray"
                        ></lsq-icon>
                    </div>
                    <div
                        class="snapshot-item mobile-amount-cluster-card"
                        (click)="
                            goToLinkOnMobile(
                                !!debtorKey
                                    ? getCustomerLink(purchasesByCustomerRouterLinkUrl)
                                    : purchasesRouterLinkUrl
                            )
                        "
                    >
                        <dashboard-amount-cluster
                            [useCurrencyPipe]="true"
                            [label]="
                                (accountSnapshotData$ | async)?.pendingInvoicesCount +
                                ' Pending Invoices'
                            "
                            i18n-label="[# of pending invoices] Pending Invoices"
                            [linkDestination]="
                                !!debtorKey
                                    ? getCustomerLink(purchasesByCustomerRouterLinkUrl)
                                    : purchasesRouterLinkUrl
                            "
                            tooltipText="Invoices that are being processed and have not yet been purchased by LSQ."
                            i18n-tooltipText="Pending Invoices dashboard tooltip"
                            [value]="(accountSnapshotData$ | async)?.pendingInvoicesAmount"
                        >
                        </dashboard-amount-cluster>
                        <lsq-icon
                            *ngIf="isMobile"
                            [type]="icons.ChevronRight"
                            [color]="color.Gray"
                        ></lsq-icon>
                    </div>
                    <div
                        class="snapshot-item mobile-amount-cluster-card"
                        (click)="
                            goToLinkOnMobile(
                                !!debtorKey
                                    ? getCustomerLink(collectionsByCustomerRouterLinkUrl)
                                    : collectionsRouterLinkUrl,
                                { startDate: startOfMonth(today), endDate: today }
                            )
                        "
                    >
                        <dashboard-amount-cluster
                            [useCurrencyPipe]="true"
                            [label]="
                                (accountSnapshotData$ | async)?.paymentsCollectedMtdCount +
                                ' Payments Collected Mtd'
                            "
                            i18n-label="
                                [# of payments collected month-to-date] Payments Collected Mtd
                            "
                            [linkDestination]="
                                !!debtorKey
                                    ? getCustomerLink(collectionsByCustomerRouterLinkUrl)
                                    : collectionsRouterLinkUrl
                            "
                            [queryParams]="{
                                startDate: startOfMonth(today),
                                endDate: today
                            }"
                            tooltipText="The month to date sum of payments that LSQ has collected from your customers."
                            i18n-tooltipText="Payments Collected dashboard tooltip"
                            [value]="(accountSnapshotData$ | async)?.paymentsCollectedMtdAmount"
                        >
                        </dashboard-amount-cluster>
                        <lsq-icon
                            *ngIf="isMobile"
                            [type]="icons.ChevronRight"
                            [color]="color.Gray"
                        ></lsq-icon>
                    </div>
                    <div
                        class="snapshot-item mobile-amount-cluster-card"
                        (click)="
                            goToLinkOnMobile(
                                !!debtorKey
                                    ? getCustomerLink(ineligiblesByCustomerRouterLinkUrl)
                                    : ineligiblesRouterLinkUrl
                            )
                        "
                    >
                        <dashboard-amount-cluster
                            [useCurrencyPipe]="true"
                            [label]="
                                (accountSnapshotData$ | async)?.ineligibleCount +
                                ' Ineligible Invoices'
                            "
                            i18n-label="[# of ineligible invoices] Ineligible Invoices"
                            [linkDestination]="
                                !!debtorKey
                                    ? getCustomerLink(ineligiblesByCustomerRouterLinkUrl)
                                    : ineligiblesRouterLinkUrl
                            "
                            tooltipText="Invoices that LSQ will not fund against. An invoice may become ineligible because it is: missing verification, past due, over credit limit, in dispute, etc."
                            i18n-tooltipText="Ineligible Invoices dashboard tooltip"
                            [value]="(accountSnapshotData$ | async)?.ineligibleAmount"
                        >
                        </dashboard-amount-cluster>
                        <lsq-icon
                            *ngIf="isMobile"
                            [type]="icons.ChevronRight"
                            [color]="color.Gray"
                        ></lsq-icon>
                    </div>
                    <div
                        class="snapshot-item mobile-amount-cluster-card"
                        (click)="
                            goToLinkOnMobile(
                                !!debtorKey
                                    ? getCustomerLink(collectionsByCustomerRouterLinkUrl)
                                    : collectionsRouterLinkUrl
                            )
                        "
                    >
                        <dashboard-amount-cluster
                            [useCurrencyPipe]="true"
                            [label]="
                                (accountSnapshotData$ | async)?.pendingCollectionsCount +
                                ' Pending Collections'
                            "
                            i18n-label="[# of pending collections] Pending Collections"
                            [linkDestination]="
                                !!debtorKey
                                    ? getCustomerLink(collectionsByCustomerRouterLinkUrl)
                                    : collectionsRouterLinkUrl
                            "
                            tooltipText="Invoice payments that LSQ received from your customers but have not yet posted to your account. Collections post to your account at the end of the business day and show as pending until then."
                            i18n-tooltipText="Pending Collections dashboard tooltip"
                            [value]="(accountSnapshotData$ | async)?.pendingCollectionsAmount"
                        >
                        </dashboard-amount-cluster>
                        <lsq-icon
                            *ngIf="isMobile"
                            [type]="icons.ChevronRight"
                            [color]="color.Gray"
                        ></lsq-icon>
                    </div>
                    <div
                        *ngIf="!debtorKey"
                        id="funds-outstanding-card-tour"
                        class="snapshot-item mobile-amount-cluster-card"
                    >
                        <dashboard-amount-cluster
                            [useCurrencyPipe]="true"
                            label="Funds Outstanding"
                            i18n-label="[Dollar amount of funds outstanding] Funds Outstanding"
                            tooltipText="The outstanding balance of funds that LSQ has advanced to your account."
                            i18n-tooltipText="Funds Outstanding dashboard tooltip"
                            [linkDestination]="availableFundsSummaryRouterLinkUrl"
                            [value]="(accountSnapshotData$ | async)?.fundsOutstanding"
                        >
                        </dashboard-amount-cluster>
                    </div>
                </div>
            </ng-container>
        </div>
    </card>
</div>
